module.exports = __webpack_public_path__ + "img/default_system_icon@2x.cc786fa9.png";